import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';

const SUCCESS_CLASS = 'Success';

/**
 * Checks if the service call was successful
 * @param response
 */
export const checkIfResponseSuccess = (response: SingleResponseMessage) =>
    response?.ResponseClass === SUCCESS_CLASS;
